import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standby-dashboard',
  templateUrl: './standby-dashboard.component.html',
  styleUrls: ['./standby-dashboard.component.scss']
})
export class StandbyDashboardComponent implements OnInit {

  constructor() { }

  public chartType = 'line';

  public chartDatasets: Array<any> = [
    {data: [131.85, 620.86, 720.12, 504.11, 473.94, 529.24, 367.39], label: 'LA Pay'},
    {data: [217.96, 964.67, 790.92, 990.56, 627.89, 597.00, 760.38], label: 'NY Pay'},
  ];

  public chart1Labels: Array<any> = [
    '12-7', '12-6', '12-5', '12-4', '12-3', '12-2', '12-1'];

  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(255,255,255,0.1)',
      borderColor: 'rgba(255,255,255,1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(255,255,255,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255,255,255,1)'
    },
    {
      backgroundColor: 'rgba(151,187,205,0.1)',
      borderColor: 'rgba(151,187,205,1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(151,187,205,1)'
    }
  ];

  public chartOptions: any = {
    responsive: true,
    legend: {
      labels: {
        fontColor: '#5b5f62',
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          fontColor: '#5b5f62',
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: '#5b5f62',
        }
      }]
    }
  };

  ngOnInit() {
  }

}
